import React, { type JSX } from "react";
import Header_Component from "../../Header_Component";
import MainContentArea_Component from "../../MainContentArea_Component";

interface LayoutMainColumnProps {
  isMobileSidebarOpen: boolean;
  onToggleSidebar: () => void;
  onOpenWelcomeModal?: () => void;
}

/**
 * Header + content column. `overflow-hidden` prevents iOS WebKit from
 * scrolling this container when focusing the chat input (which would shift
 * the header off-screen by exactly the header height).
 */
export default function LayoutMainColumn({
  isMobileSidebarOpen,
  onToggleSidebar,
  onOpenWelcomeModal,
}: LayoutMainColumnProps): JSX.Element {
  return (
    <div className="flex-1 min-w-0 flex flex-col overflow-hidden">
      <Header_Component
        onToggleSidebar={onToggleSidebar}
        isMobileSidebarOpen={isMobileSidebarOpen}
        onOpenWelcomeModal={onOpenWelcomeModal}
      />

      {/* Main Content Area - responsive padding with smooth transitions */}
      <div className="flex-1 min-h-0 overflow-hidden">
        <div className="h-full transition-[width] duration-200">
          <MainContentArea_Component />
        </div>
      </div>
    </div>
  );
}
